<form name="businessFunctionForm" [formGroup]="businessFunctionForm" novalidate>

    <div class="pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
        <div class="row justify-content-between align-items-center m-0">
            <p class="mb-0 h3">
                <i class="fa fa-cog mr-3"></i>
                Configuration
            </p>
            <button *ngIf="!isNewBusinessFunction" type="submit" class="btn btn-sm btn-primary btn"
                    [disabled]="!businessFunctionForm.valid"
                    (click)="updateBusinessFunction(businessFunctionForm.value, businessFunctionForm.valid)">
                Save changes
                <i class="fa fa-check ml-2"></i>
            </button>
            <button *ngIf="isNewBusinessFunction" type="submit" class="btn btn-sm btn-primary btn"
                    [disabled]="!businessFunctionForm.valid"
                    (click)="createBusinessFunction(businessFunctionForm.value, businessFunctionForm.valid)">
                Create business function
                <i class="fa fa-check ml-2"></i>
            </button>
        </div>
    </div>

    <div class="container mt-5">
        <div class="row">
            <div class="col">
                <div class="card mb-4">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Basic settings</p>
                    </div>
                    <div class="card-body">
                        <ng-container *ngIf="isSuperAdmin">
                            <div class="form-group mb-4"
                                 [ngClass]="{ 'has-error' : !businessFunctionForm.controls['defaultRoute'].valid && businessFunctionForm.controls['defaultRoute'].touched }">
                                <label>URL Path *</label>
                                <p id="namehelptext" class="form-text">
                                    The <strong>path</strong> forms the URL through
                                    which users will access the portal. It should contain no spaces or special
                                    characters.
                                </p>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <div class="input-group-addon">taxcms.deloitte.com/</div>
                                    <input type="text" class="form-control" [readonly]="pathLocked"
                                           formControlName="defaultRoute" name="defaultRoute"
                                           aria-describedby="namehelptext" /> &nbsp;
                                    <i *ngIf="!isNewBusinessFunction" class="fa mr-2"
                                       [ngClass]="{ 'fa-lock' : pathLocked, 'fa-unlock' : !pathLocked}"
                                       (click)="togglePathLocked();"></i>
                                </div>
                                <p *ngIf="!isNewBusinessFunction && !pathLocked">
                                    Previously published links for this
                                    business function (e.g. in email notifications, latest updates, etc.) will no longer
                                    work if the URL path is changed.
                                </p>
                                <div *ngIf="businessFunctionForm.controls['defaultRoute'].hasError('required') && businessFunctionForm.controls['defaultRoute'].touched"
                                     class="alert alert-danger mt-3">You must provide a path.</div>
                                <div *ngIf="businessFunctionForm.controls['defaultRoute'].hasError('pattern') && businessFunctionForm.controls['defaultRoute'].touched"
                                     class="alert alert-danger">This path is invalid.</div>
                            </div>

                            <div class="form-group mb-4"
                                 [ngClass]="{ 'has-error' : !businessFunctionForm.controls['displayName'].valid && businessFunctionForm.controls['displayName'].touched }">
                                <label for="title">Portal name *</label>
                                <p id="displayNamehelptext" class="form-text">What is the portal's full name</p>
                                <input type="text" class="form-control" formControlName="displayName" name="displayName"
                                       aria-describedby="displayNamehelptext" />
                                <div *ngIf="businessFunctionForm.controls['displayName'].hasError('required') && businessFunctionForm.controls['displayName'].touched"
                                     class="alert alert-danger mt-3">You must include a display name.</div>
                            </div>

                            <div class="form-group mb-4">
                                <label for="title">Authentication </label>
                                <p class="form-text" id="authenticationText">
                                    Is your portal publically accessible? Or
                                    will it require a user account?
                                </p>
                                <p>
                                    <input type="checkbox" name="authenticationRequired"
                                           formControlName="authenticationRequired" />
                                    This portal is <strong>private</strong> and only accessible via a user account
                                </p>
                            </div>
                            <div class="form-group mb-4">
                                <label for="title">Deloitte User Access</label>
                                <p class="form-text" id="deloitteUserTest">
                                    Is your portal accessible to all Deloitte
                                    users? Or will it require provisioning?
                                </p>
                                <p>
                                    <input type="checkbox" name="deloitteUserAcess"
                                           formControlName="deloitteClientAccess" />
                                    This portal is available to <strong>all</strong> Deloitte users. (Users with a
                                    @deloitte email address)
                                </p>
                            </div>
                        </ng-container>
                        <div class="form-group"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['email'].valid && businessFunctionForm.controls['email'].touched }">
                            <label for="email">Contact email * </label>
                            <p class="form-text" id="emailhelptext">
                                This address is used as the main contact point for
                                users of the portal
                            </p>
                            <input type="text" class="form-control" formControlName="email" name="email"
                                   aria-describedby="emailhelptext" />
                            <div *ngIf="businessFunctionForm.controls['email'].invalid && businessFunctionForm.controls['email'].touched"
                                 class="alert alert-danger mt-3">Invalid Email format.</div>
                            <div *ngIf="businessFunctionForm.controls['email'].hasError('required') && businessFunctionForm.controls['email'].touched"
                                 class="alert alert-danger mt-3">You must include an email address.</div>
                        </div>
                    </div>
                </div>

                <div class="card mb-4">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Homepage content</p>
                    </div>
                    <div class="card-body">
                        <div class="row"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['headerText'].valid && businessFunctionForm.controls['headerText'].touched }">
                            <div class="col">
                                <div class="form-group mb-4">
                                    <label for="headerText">Portal header*</label>
                                    <p class="form-text" id="headerTexthelptext">
                                        This text forms the subheading of the
                                        homepage banner. Try to keep this section short and consise.
                                    </p>
                                    <textarea class="form-control" formControlName="headerText"
                                              aria-describedby="headerTexthelptext" name="headerText"
                                              maxlength="{{portalHeaderMaxLength}}"></textarea>
                                    <small class="text-muted">
                                        {{portalHeaderMaxLength - businessFunctionForm.controls['headerText'].value?.length}}
                                        characters remaining
                                    </small>
                                    <div *ngIf="businessFunctionForm.controls['headerText'].hasError('required') && businessFunctionForm.controls['headerText'].touched"
                                         class="alert alert-danger mt-3">You must include a portal header.</div>
                                </div>

                                <div class="form-group">
                                    <label for="overviewText">Portal overview</label>
                                    <p class="form-text" id="overviewTexthelptext">
                                        If required, you can provide additional information beneath the subheading on
                                        the homepage banner. Where possible, avoid using this option.
                                    </p>
                                    <textarea class="form-control" formControlName="overviewText"
                                              aria-describedby="overviewTexthelptext" name="overviewText" rows="5"
                                              maxlength="{{portalOverviewMaxLength}}"></textarea>
                                    <small class="text-muted">
                                        {{portalOverviewMaxLength - businessFunctionForm.controls['overviewText'].value?.length}}
                                        characters remaining
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-4" *ngIf="isSuperAdmin">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Legal content</p>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-4"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['disclaimers'].valid && businessFunctionForm.controls['disclaimers'].touched }">
                            <label for="disclaimers">Disclaimer*</label>
                            <p class="form-text" id="disclaimershelptext">
                                The disclaimer appears as for <strong>first time users</strong> and must be accepted
                                before the user can use the tool.
                            </p>
                            <ckeditor formControlName="disclaimers" aria-describedby="disclaimershelptext"
                                      [editor]="Editor" [config]="config" ckEditorEnhanced>
                            </ckeditor>
                            <div *ngIf="businessFunctionForm.controls['disclaimers'].hasError('required') && businessFunctionForm.controls['disclaimers'].touched"
                                 class="alert alert-danger mt-3">You must include a disclaimer.</div>
                        </div>

                        <div class="form-group mb-4"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['legalInformation'].valid && businessFunctionForm.controls['legalInformation'].touched }">
                            <label for="legalInformation">Legal information*</label>
                            <p class="form-text" id="legalInformationhelptext">
                                Legal information is visible at the <strong>bottom of each page</strong>.
                            </p>
                            <ckeditor formControlName="legalInformation" aria-describedby="legalInformationhelptext"
                                      [editor]="Editor" [config]="config" ckEditorEnhanced>
                            </ckeditor>
                            <div *ngIf="businessFunctionForm.controls['legalInformation'].hasError('required') && businessFunctionForm.controls['legalInformation'].touched"
                                 class="alert alert-danger mt-3">You must include legal information.</div>
                        </div>

                        <div class="form-group"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['pdfLegalInformation'].valid && businessFunctionForm.controls['pdfLegalInformation'].touched }"
                             *ngIf="!isNewBusinessFunction">
                            <label for="pdfLegalInformation">PDF legal information</label>
                            <p class="form-text" id="pdfLegalInformationhelptext">
                                PDF specific information is present on <strong>each page</strong> of a PDF, downloaded
                                from the portal.
                            </p>
                            <textarea class="form-control" formControlName="pdfLegalInformation"
                                      aria-describedby="pdfLegalInformationhelptext" name="pdfLegalInformation" rows="5"
                                      maxlength="{{pdfLegalMaxLength}}"></textarea>
                            <small class="text-muted">
                                {{pdfLegalMaxLength - businessFunctionForm.controls['pdfLegalInformation'].value?.length}}
                                characters remaining
                            </small>
                        </div>
                    </div>
                </div>

                <div class="card mb-4" *ngIf="!isNewBusinessFunction">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Additional information</p>
                    </div>
                    <div class="card-body">
                        <div class="row mb-0"
                             [ngClass]="{ 'has-error' : !businessFunctionForm.controls['about'].valid && businessFunctionForm.controls['about'].touched }">
                            <div class="col">
                                <div class="form-group">
                                    <label for="about">About content</label>
                                    <p class="form-text" id="abouthelptext">
                                        Information provided here will be available
                                        via the <strong>About</strong> page and should document the portal's audience
                                        and intended use. It may also be helpful to include information around technical
                                        terms or metrics used present within the portal's content.
                                    </p>
                                    <ckeditor formControlName="about" aria-describedby="abouthelptext"
                                              [editor]="Editor" [config]="config" ckEditorEnhanced>
                                    </ckeditor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-4" *ngIf="isSuperAdmin">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Features</p>
                    </div>
                    <div class="card-body">
                        <div class="row" formArrayName="features">
                            <div *ngFor="let feat of businessFunctionForm.controls['features'].controls; let i=index"
                                 class="col col-4">
                                <div [formGroupName]="i">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input type="checkbox" class="form-check-input" formControlName="enabled">
                                            <label>{{feat.value.name}}</label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-4" *ngIf="isSuperAdmin">
                    <div class="card-header bg-primary text-white">
                        <p class="h3 m-0" for="title">Bespoke branding</p>
                    </div>
                    <div class="card-body">
                        <p class="form-text" *ngIf="selectedLink == 'Bespoke'">
                            The logo should meet the Deloitte branding guidelines,
                            please consult Brandspace on Deloitte Net to check the requirements.
                            Logo should be 155 X 45 pixels in dimension and not more than 3 MB in size.

                        </p>
                        <div class="radio">
                            <label class="mr-3">
                                <input type="radio" name="radio" ng-true-value="Default" (click)="setLogoType('Default')" ngmodel [checked]="defaultLogoChecked">
                                Default
                            </label>

                            <label>
                                <input type="radio" name="radio" ng-true-value="Bespoke" (click)="setLogoType('Bespoke')" ngmodel [checked]="bespokeLogoChecked">
                                Bespoke
                            </label>
                        </div>

                        <div *ngIf="isSelected('Default')" class="navbar-brand ml-1">
                            <img src="/images/deloitte-black.svg" class="defaultLogoDimension" title="Deloitte" />

                        </div>
                        <div class="mt-2" *ngIf="isSelected('Bespoke')">
                            <div class="mb-0">
                                <label>
                                    <img [src]="encodedImage" *ngIf="encodedImage" class="mt-1 mb-3 bespokeLogoDimension mr-5" />
                                    <label *ngIf="!encodedImage" class="ml-1 bg-faded form-text">Click on 'Add image'</label>
                                </label>
                            </div>
                            <div class="mt-0">
                                <input type="file" #file hidden (change)="selectFile($event)" name="logo" accept="image/*">
                                <button class="btn btn-sm btn-primary btn" (click)="file.click()">Add Image<i class="fa fa-upload ml-2"></i></button>
                                <button class="btn btn-sm btn-primary btn" (click)="deleteImage()" *ngIf="removeImageButtonVisibility">
                                    Remove Image
                                </button>
                                <small><label class="text-danger bg-faded ml-2">{{imageErrorMsg}}</label></small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-4" *ngIf="!isNewBusinessFunction">
                    <keycontacts [keyContacts]="businessFunction?.keyContacts"></keycontacts>
                </div>
            </div>
        </div>
    </div>
</form>


<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>